import { useReactiveVar } from '@apollo/client'
import USBLink from '@usb-shield/react-link/dist/esm'
import { BASE_PATH } from '../../../../../config/connections'
import routerpath from '../../../../../constants/routerpath'
import { userAccount } from '../../../../../graphql/cache/localCache'
import { useMultilingualService } from '../../../../../service/multilingualService'
import { navigateRoute } from '../../../../../utils/browserutils'

/**
 * @typedef {Object} search error
 */
/**
 * Returns error link
 * @function
 * @returns {HTMLElement} Returns error message with redirection link
 */

const Error = () => {
  const { ERROR_COMPONENT } = useMultilingualService('addBillDashboard')
  const { navigateRoutePath } = navigateRoute()
  const onAddbillManually = () => {
    navigateRoutePath(`${BASE_PATH}${routerpath.pages.manual}`)
  }
  const { isSafeDebit = false } = useReactiveVar(userAccount) || {}
  return (
    <div>
      <p id="searchbiller-error">
        <span href="#" id="searchbiller-addbillmanually">
          {!isSafeDebit ? (
            <>
              {ERROR_COMPONENT?.DASHBOARD_ERROR_DESC_WITH_OR}{' '}
              <USBLink linkType="basic" handleClick={onAddbillManually}>
                {ERROR_COMPONENT?.DASHBOARD_ADD_BILL_MANUALLY}
              </USBLink>
            </>
          ) : (
            <> {ERROR_COMPONENT?.DASHBOARD_ERROR_DESC} </>
          )}
          .
        </span>
      </p>
    </div>
  )
}

Error.propTypes = {}

export default Error
